<template lang="pug">
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  @input='$emit("input", $event)'
  @change='$emit("change", $event)'
  :items='list'
  item-value='id'
  item-text='name'
)
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import picker from '@/mixins/picker'

export default {
  mixins: [picker],

  props: {
    label: {
      default: 'Выберите JSON схему'
    }
  },

  created() {
    this.fetch()
  },

  methods: mapActions('dictionary/jsontemplates', ['fetch']),
  computed: mapGetters('dictionary/jsontemplates', ['list'])
}
</script>
